import styles from 'components/sections/search/PaletteSearchResult.module.scss';
import {InfiniteScrollGrid} from "components/list/InfiniteScrollGrid";
import PostListContext, {CHUNK_SIZE} from "context/PostListContext";
import SimplePostListCard, {SimplePostCardPlaceholder} from "components/cards/SimplePostListCard";
import {getSinglePaletteRoute} from "common/const";
import {useContext, useEffect} from "react";
import RecommendedQueries from "components/sections/search/RecommendedQueries";
import {KEY_PALETTE} from "components/sections/search/SearchResult";
import {NoPaletteSearchResult} from "components/sections/search/NoSearchResult";
import {SearchSectionComponentId} from "components/sections/SearchSection";
import LoadingSearchResult, {SearchResultError} from "components/sections/search/LoadingSearchResult";


const PaletteSearchResult = (props) => {
    const {query, setQuery, recommendedQueries, onItemClick} = props;
    const postListContext = useContext(PostListContext);

    const loadMoreRows = (startIndex, stopIndex) => {
        return postListContext.loadMoreRows(query, startIndex, stopIndex);
    };

    useEffect(() => {
        typeof mixpanel !== 'undefined' && mixpanel.track(
            'ViewPaletteSearchResult',
            {query},
        );
    }, []);

    const onPostClick = (post, itemIndex) => {
        typeof mixpanel !== 'undefined' && mixpanel.track(
            'PaletteSearchResultPostClick', {postId: post.id, query, itemIndex}
        )
        onItemClick();
    };

    const getItemComponent = (item) => {
        item.media = item.media_list.length > 0 ? item.media_list[0] : null;
        item.media_count = item.media_list.length;
        return <SimplePostListCard
            post={item} marginBottom={20} showProduct
            linkOverride={getSinglePaletteRoute(query, item.index)}
            onPostClick={(post) => onPostClick(post, item.index)}
        />
    };

    const renderPlaceholder = (index) => {
        return <SimplePostCardPlaceholder showProduct key={index}/>
    };

    useEffect(() => {
        if (!Boolean(postListContext.queryToPostList[query]?.storage)) {
            loadMoreRows(0, CHUNK_SIZE);
        }
    }, [query]);

    const handleRefresh = () => {
        postListContext.reset(query, () => {
            loadMoreRows(0, CHUNK_SIZE);
        });
    };

    return (
        <div>
            {
                query
                    ?
                    (
                        postListContext.queryToPostList[query]
                            ?
                            (
                                postListContext.queryToPostList[query].error
                                    ? <SearchResultError handleRefresh={handleRefresh}/>
                                    : (
                                        postListContext.queryToPostList[query]?.finalRowCount !== 0
                                            ?
                                            <div className={styles.container}>
                                                <InfiniteScrollGrid
                                                    key={`InfiniteScrollGrid_${query}`}
                                                    colCount={2}
                                                    remoteRowCount={
                                                        postListContext.queryToPostList[query]?.finalRowCount ||
                                                        postListContext.queryToPostList[query]?.rowCount || CHUNK_SIZE
                                                    }
                                                    expectedRowHeight={336}
                                                    chunkSize={CHUNK_SIZE * 2}
                                                    renderRow={getItemComponent}
                                                    fetchData={loadMoreRows}
                                                    dataStorage={postListContext.queryToPostList[query]?.storage || []}
                                                    renderPlaceholder={renderPlaceholder}
                                                    scrollTargetId={SearchSectionComponentId}
                                                />
                                                <div className={styles.bottomPadding}/>
                                            </div>
                                            :
                                            <NoPaletteSearchResult query={query}/>
                                    )
                            )
                            : <LoadingSearchResult/>
                    )
                    :
                    <div className={styles.container}>
                        <RecommendedQueries
                            category={KEY_PALETTE} searchQuery={setQuery}
                            recommendedQueries={recommendedQueries}
                        />
                    </div>
            }
        </div>
    )
};

export default PaletteSearchResult;
